import { useEffect } from "react";
import { useApiGet } from "../../../utils/api";
import { DashboardRefreshButton } from "./dashboard_refresh_button";
import { FeedingWidget } from "./widgets/feeding_widget";
import { PastFeedingsWidget } from "./widgets/past_feedings_widget";
import { DiaperChangeWidget } from "./widgets/diaper_change_widget";
import { PumpingWidget } from "./widgets/pumping_widget";
import { WeighingWidget } from "./widgets/weighing_widget";

export const Dashboard = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/dashboard");

  useEffect(() => {
    const interval = setInterval(() => refetch(), 60000);
    return () => clearInterval(interval);
  }, []);

  if (unavailable) return unavailable;

  return (
    <div
      className="container-fluid"
      style={{ position: "relative", minHeight: "87vh" }}
    >
      <div className="row">
        <FeedingWidget lastFeeding={data?.last_feeding} refetch={refetch} />
        <PastFeedingsWidget pastFeedings={data?.past_feedings} />
      </div>
      <div className="row">
        <DiaperChangeWidget
          lastDiaperChange={data?.last_diaper_change}
          refetch={refetch}
        />
        <PumpingWidget lastPumping={data?.last_pumping} refetch={refetch} />
      </div>
      <div className="row">
        <WeighingWidget lastWeighing={data?.last_weighing} refetch={refetch} />
      </div>
      <DashboardRefreshButton />
    </div>
  );
};
